import { CompanyDetailSelectModel } from 'hq/services/mappers/mappers';
import { CompanyBranchOffices } from './tabs/company-branch-offices/company-branch-offices';
import { CompanyInfo } from './tabs/company-info/company-info';
import { CompanyGrossHourlyRateDataProvider } from './tabs/company-gross-hourly-rate/company-gross-hourly-rate';
import { CompanyOrts } from './tabs/company-orts/company-orts';

export const getCompanyDetailTabs = (data: CompanyDetailSelectModel) => {
  return [
    {
      id: 'company-information',
      tabLabel: 'Bedrijfsdetails',
      element: <CompanyInfo data={data} />,
    },
    {
      id: 'company-branch-offices',
      tabLabel: 'Vestigingen',
      element: <CompanyBranchOffices id={data.id} />,
    },
    {
      id: 'gross-hourly-rate',
      tabLabel: 'Bruto uurloon',
      element: <CompanyGrossHourlyRateDataProvider id={data.id} />,
    },
    {
      id: 'company-orts',
      tabLabel: 'ORTs',
      element: <CompanyOrts data={data} />,
    },
  ];
};
